var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 380c-3 3-3 8 0 11 4 3 9 3 12 0l166-166c6-6 9-14 9-22s-3-16-9-22L14 15c-3-3-8-3-12 0-3 3-3 9 0 12l166 166c3 3 5 6 5 10s-2 8-5 11L2 380zM392 391c3 3 9 3 12 0s3-8 0-11L238 213c-3-3-4-6-4-10s1-7 4-10L404 27c3-3 3-9 0-12s-9-3-12 0L226 181c-6 6-9 14-9 22s3 16 9 22l166 166z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideMenu);
export default __webpack_public_path__ + "static/media/HideMenu.709b6e991c13083ede6a9620c0fdb8d6.svg";
export { ForwardRef as ReactComponent };